import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [
    { id: 'id', label: t('Local-users.table-col-1') },
    { id: 'name', label: t('Local-users.table-col-2') },
    { id: 'email', label: t('Local-users.table-col-3') },
];
